import { useEffect } from "react";
import { Container } from "./YouTubeVideoEmbed.style";

const PLAYER_OPTIONS = { // 0 = false, 1 = true
	autoplay: 1,
	mute: 1,
};

export const YOUTUBE_VIDEO_EMBED_ID = "BP-youtube-video-embed";

export const grabVideoId = (url: string) => {
	let parsedURL;

	try {
		parsedURL = new URL(url);
	} catch {
		return url;
	}

	const videoIdRegex = /(?:v=|vi=|\/(?:embed|v|vi|e|live|shorts|watch)\/|youtu\.be\/)([^?&]+)/;
	const match = parsedURL.toString().match(videoIdRegex);
	return match ? match[1] : null;
};

interface YouTubeVideoEmbedProps {
	fillSpace?: boolean;
	url: string | undefined;
}

export const pauseYouTubeVideoEmbed = () => {
	const youtubePlayer = document.getElementById(YOUTUBE_VIDEO_EMBED_ID) as HTMLIFrameElement | null;

	if (youtubePlayer) {
		youtubePlayer.contentWindow?.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
	}
};

export const playYouTubeVideoEmbed = () => {
	const youtubePlayer = document.getElementById(YOUTUBE_VIDEO_EMBED_ID) as HTMLIFrameElement | null;

	if (youtubePlayer) {
		youtubePlayer.contentWindow?.postMessage("{\"event\":\"command\",\"func\":\"playVideo\",\"args\":\"\"}", "*");
	}
};

const YouTubeVideoEmbed = ({ fillSpace = false, url = "" }: YouTubeVideoEmbedProps) => {
	// Autoplay
	useEffect(() => {
		const iframe = document.querySelector("iframe");
		iframe?.setAttribute("allow", "autoplay");
	}, []);

	if (!url) {
		return null;
	}

	const parsedVideoId = grabVideoId(url);

	return (
		<Container $fillSpace={fillSpace}>
			<iframe
				id={YOUTUBE_VIDEO_EMBED_ID}
				src={`https://www.youtube.com/embed/${parsedVideoId}?autoplay=${PLAYER_OPTIONS.autoplay}&mute=${PLAYER_OPTIONS.mute}&enablejsapi=1`}
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
			/>
		</Container>
	);
};

export default YouTubeVideoEmbed;
